import type { IUseCase } from '@/shared/contracts/use-case.contract';

import type {
  GetMerchantDetailsRequest,
  GetMerchantDetailsResponse,
} from '../types/get-merchant-details';
import { ENDPOINT } from '../types/get-merchant-details';

import { HttpMethod, type IHttpClient } from '@/shared/contracts/http-client.contract';
import { rememberStoreTheme } from '@/shared/utils/store-theme';

export type UseCaseInput = GetMerchantDetailsRequest;
export type UseCaseOutput = GetMerchantDetailsResponse;

export class GetMerchantDetailsUseCase implements IUseCase<UseCaseInput, UseCaseOutput> {
  private client: IHttpClient;

  constructor(client: IHttpClient) {
    this.client = client;
  }

  async execute(input: UseCaseInput): Promise<UseCaseOutput> {
    const { slug, latitude, longitude } = input;

    if (!slug) {
      throw new Error('Slug is required');
    }

    // Monta query params se latitude e longitude estiverem presentes
    const queryParams = new URLSearchParams();
    if (latitude && longitude) {
      queryParams.append('latitude', latitude);
      queryParams.append('longitude', longitude);
    }

    const queryString = queryParams.toString();
    const endpoint = queryString 
      ? `${ENDPOINT}/${slug}/details?${queryString}`
      : `${ENDPOINT}/${slug}/details`;

    const response = await this.client.sendRequest<UseCaseOutput, never>({
      method: HttpMethod.GET,
      endpoint,
    });

    // Toda tela que lê os detalhes da loja atualiza as cores do app (PRAT-154).
    rememberStoreTheme(slug, response?.app_theme);

    return response;
  }
}
